import Page from "../../shared/Page";
import QuestionResultRenderer from "./components/QuestionResultRenderer";
import FirebaseAuth from "../../shared/FirebaseAuth/FirebaseAuth";
import Loader from "../../ui/Loader";

import useFirebaseProject from "../../../helpers/hooks/useFirebaseProject";
import usePollResults from "./hooks/usePollResults";
import useOpenEndedResponses from "./hooks/useOpenEndedResponses";
import useCsvExport from "./hooks/useCsvExport";

import { useSelector } from "react-redux";

const PollingResults = ({ match }) => {
	const { appKey, pageId } = match.params;
	const appConfig = useSelector(state => state.appConfig.appConfig);
	const firebaseApp = useFirebaseProject(appConfig, appKey);
	const { results, loading } = usePollResults(firebaseApp, pageId);
	const { openEndedResponses, loading: openEndedLoading } = useOpenEndedResponses(firebaseApp, pageId);
	const { exportCsv, isExporting } = useCsvExport(firebaseApp);
	const pollingPages = useSelector(state => state.pages.pollingPages);

	const pollPage = pollingPages[pageId]?.properties || {};
	const pollQuestions = pollPage?.questions || [];

	const pageName = "Polling Results";

	const handleExportOverview = () => {
		exportCsv(
			`/api/polls/${pageId}/export/overview.csv`,
			{ moduleId: pageId, page: pollPage, timezone: "UTC", includeSkips: true },
			"overview"
		);
	};

	const handleExportAttendees = () => {
		exportCsv(
			`/api/polls/${pageId}/export/attendees.csv`,
			{ moduleId: pageId, page: pollPage, timezone: "UTC" },
			"attendees"
		);
	};

	if (!firebaseApp) {
		return (
			<div className="ta-center">
				<Loader />
			</div>
		);
	}

	return (
		<FirebaseAuth firebaseApp={firebaseApp}>
			<Page title={`Poll Results - ${pageId}`}>
				{loading || openEndedLoading ? (
					<div className="ta-center">
						<Loader />
					</div>
				) : (
					<div className="polling-results">
						<div className="title wrapper">
							<h3 className="page-title">{pageName}</h3>
						</div>
						<div className="export-controls">
							<button
								className={`btn btn-primary${isExporting("overview") ? " btn-disabled" : ""}`}
								onClick={handleExportOverview}
								disabled={isExporting("overview")}
							>
								{isExporting("overview") ? (
									<>
										<i className="fal fa-spinner-third fa-spin"></i> Exporting Overview...
									</>
								) : (
									"Export Results Overview"
								)}
							</button>
							<button
								className={`btn btn-primary${isExporting("attendees") ? " btn-disabled" : ""}`}
								onClick={handleExportAttendees}
								disabled={isExporting("attendees")}
							>
								{isExporting("attendees") ? (
									<>
										<i className="fal fa-spinner-third fa-spin"></i> Exporting Attendees...
									</>
								) : (
									"Export Attendee Results"
								)}
							</button>
						</div>
						{results.length === 0 && openEndedResponses.length === 0 ? (
							<div className="chart-container">
								<div className="chart-content">
									<p className="note">No results found.</p>
								</div>
							</div>
						) : (
							<div>
								{pollQuestions.map((question, index) => (
									<QuestionResultRenderer
										key={question.key || index}
										question={question}
										results={results}
										openEndedResponses={openEndedResponses}
									/>
								))}
							</div>
						)}
						<div
							className="btn m-top btn-block"
							onClick={() => {
								firebaseApp.auth().signOut();
							}}
						>
							Switch User
						</div>
					</div>
				)}
			</Page>
		</FirebaseAuth>
	);
};

export default PollingResults;
